export default __webpack_public_path__ + "static/media/no.d899b529.jpg";